import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from 'assets/icons/barcode.svg'
import _imports_1 from 'assets/icons/serial.svg'


const _hoisted_1 = { class: "selectable-product__quantity-wrapper" }
const _hoisted_2 = { class: "selectable-product__quantity" }
const _hoisted_3 = { class: "selectable-product__main-wrapper" }
const _hoisted_4 = { class: "selectable-product__top-wrapper" }
const _hoisted_5 = { class: "selectable-product__product space-v2" }
const _hoisted_6 = { class: "selectable-product__title" }
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = { class: "selectable-product__bottom-wrapper" }
const _hoisted_9 = { class: "selectable-product__product-wrapper" }
const _hoisted_10 = { class: "selectable-product__product-title" }
const _hoisted_11 = {
  key: 0,
  class: "selectable-product__header"
}
const _hoisted_12 = { class: "selectable-product__quantity" }
const _hoisted_13 = {
  class: "selectable-product__main-wrapper",
  style: {"display":"flex","flex-direction":"revert","justify-content":"space-between"}
}
const _hoisted_14 = { class: "selectable-product__middle-wrapper" }
const _hoisted_15 = {
  key: 0,
  class: "selectable-product__meta selectable-product__ean--container"
}
const _hoisted_16 = {
  key: 1,
  class: "selectable-product__meta selectable-product__ean--container"
}
const _hoisted_17 = { class: "selectable-product__ean" }
const _hoisted_18 = { class: "selectable-product__meta selectable-product__serial--container" }
const _hoisted_19 = { class: "selectable-product__serial" }
const _hoisted_20 = {
  class: "selectable-product__title-wrapper",
  style: {"display":"flex"}
}
const _hoisted_21 = { class: "selectable-product__title" }
const _hoisted_22 = {
  class: "selectable-product__top-wrapper",
  style: {"display":"flex"}
}
const _hoisted_23 = { class: "selectable-product__buttons" }
const _hoisted_24 = {
  key: 0,
  class: "selectable-product__expanded"
}
const _hoisted_25 = { class: "receive-item__minimal-body" }
const _hoisted_26 = { class: "receive-item__header" }
const _hoisted_27 = { class: "receive-item__subtitle" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "receive-item__title" }
const _hoisted_30 = { class: "receive-item__action-buttons" }
const _hoisted_31 = {
  key: 0,
  class: "receive-item__expanded-body"
}
const _hoisted_32 = { class: "receive__ean" }
const _hoisted_33 = {
  key: 1,
  class: "receive-item__default-container"
}
const _hoisted_34 = { class: "receive-item__minimal-body" }
const _hoisted_35 = { class: "receive-item__header" }
const _hoisted_36 = { class: "receive-item__subtitle" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "receive-item__title" }
const _hoisted_39 = { class: "receive-item__action-button" }
const _hoisted_40 = {
  key: 0,
  class: "receive-item__expanded-body"
}
const _hoisted_41 = {
  key: 2,
  class: "selectable-item__expanded"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_simple_link = _resolveComponent("simple-link")!
  const _component_quantity_container = _resolveComponent("quantity-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["selectable-item__container", { selected: _ctx.selected, active: _ctx.isActive,  [`layout__${_ctx.layout || 'none'}`]: true}]),
    "data-cy": "selectable-item-container",
    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (!_ctx.layout ? _ctx.select() : _ctx.setActive(!_ctx.focused)), ["stop"])),
    onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeOnFocus && _ctx.setActive(true))),
    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeOnFocus && _ctx.setActive(false)))
  }, [
    (!_ctx.payload)
      ? _renderSlot(_ctx.$slots, "placeholder", {
          key: 0,
          payload: _ctx.payload,
          index: _ctx.index,
          select: _ctx.select,
          selected: _ctx.selected
        }, () => [
          _createVNode(_component_spinner, {
            scale: 0.5,
            visible: true,
            style: {"margin":"0 auto","width":"50px"}
          })
        ], true)
      : _renderSlot(_ctx.$slots, "default", {
          key: 1,
          payload: _ctx.payload,
          index: _ctx.index,
          selected: _ctx.selected,
          active: _ctx.isActive,
          expanded: _ctx.payload == _ctx.active,
          expand: _ctx.$emit('expand', true),
          close: _ctx.$emit('expand', false)
        }, () => [
          (_ctx.layout === _ctx.ItemLayoutType.Location)
            ? (_openBlock(), _createBlock(_component_simple_link, {
                key: 0,
                class: _normalizeClass(["selectable-product selectable-product--location", { 'selectable-product--selected': _ctx.selected}]),
                id: _ctx.payload,
                style: {'padding': '0', 'margin-right': '0px'},
                level: 1,
                store: _ctx.currentCache,
                "onUpdate:store": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentCache) = $event))
              }, {
                default: _withCtx(({ resolved }) => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.meta?.quantity), 1)
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("h5", null, [
                          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "bold" }, "Warehouse ", -1)),
                          _createElementVNode("span", null, _toDisplayString(resolved?.storage_location?.id !== 'warehouse' ? `— ${_ctx.format.title(resolved?.storage_location?.id || '')}` : ''), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(resolved?.name || resolved?.id || resolved?.title || '...') + " ", 1),
                        _createElementVNode("span", null, _toDisplayString((resolved?.name || resolved?.id || resolved?.title) ? `${resolved?.stock_item?.ean?.length ? ' — ' : ''} ${resolved?.stock_item?.ean?.[0] || ''}` : `${resolved?.stock_item?.ean?.[0] || ''}`), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(resolved?.stock_item?.sku || resolved?.stock_item?.ean?.join(', ') || '') + " " + _toDisplayString((resolved?.stock_item?.sku || resolved?.stock_item?.ean) ? '—' : '') + " " + _toDisplayString(resolved?.stock_item?.title || '...'), 1)
                      ]),
                      _withDirectives(_createVNode(_component_ozn_button, {
                        class: "selectable-product__button",
                        disabled: _ctx.disabled,
                        onClick: _withModifiers(_ctx.select, ["stop"])
                      }, null, 8, ["disabled", "onClick"]), [
                        [_vShow, !_ctx.selected]
                      ]),
                      _withDirectives(_createVNode(_component_ozn_button, {
                        class: "selectable-product__button",
                        disabled: _ctx.disabled,
                        onClick: _withModifiers(_ctx.remove, ["stop"])
                      }, null, 8, ["disabled", "onClick"]), [
                        [_vShow, _ctx.selected]
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["id", "class", "store"]))
            : _createCommentVNode("", true),
          (_ctx.layout === _ctx.ItemLayoutType.Product)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["selectable-product selectable-product--product", { 'selectable-product--selected': _ctx.selected}])
              }, [
                (_ctx.payload?.header)
                  ? (_openBlock(), _createElementBlock("header", _hoisted_11, _toDisplayString(_ctx.format.title(_ctx.payload?.header || 'Package')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "selectable-product__quantity-wrapper",
                  style: _normalizeStyle({'background-color': (_ctx.payload as any)?.quantity === 1 ? 'var(--directr__carolina-blue)' : undefined})
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString((_ctx.payload as any)?.quantity || '-'), 1)
                ], 4),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    ((_ctx.payload as any)?.ean?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[6] || (_cache[6] = _createElementVNode("img", {
                            class: "selectable-product__ean-icon",
                            src: _imports_0,
                            style: {"display":"inline-block","margin-right":"5px","margin-bottom":"2px"}
                          }, null, -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["selectable-product__ean", {'warn darken': !(_ctx.payload as any)?.ean?.length}])
                          }, _toDisplayString((_ctx.payload as any)?.ean?.length ? ((Array.isArray(_ctx.payload.ean) ? _ctx.payload.ean[0] : _ctx.payload.ean) || '-') : ((_ctx.payload as any)?.sku || 'item has no ean...')), 3)
                        ]))
                      : _createCommentVNode("", true),
                    (String((_ctx.payload as any)?.sku || '')?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _cache[7] || (_cache[7] = _createElementVNode("img", {
                            class: "selectable-product__ean-icon",
                            src: _imports_0,
                            style: {"display":"inline-block","margin-right":"5px","margin-bottom":"2px"}
                          }, null, -1)),
                          _createElementVNode("span", _hoisted_17, _toDisplayString((_ctx.payload as any)?.sku), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", _hoisted_18, [
                      _cache[8] || (_cache[8] = _createElementVNode("img", {
                        class: "selectable-product__serial-icon",
                        src: _imports_1,
                        style: {"display":"inline-block","margin-right":"5px","margin-bottom":"2px"}
                      }, null, -1)),
                      _createElementVNode("span", _hoisted_19, _toDisplayString((_ctx.payload as any).serial_id), 1)
                    ], 512), [
                      [_vShow, (_ctx.payload as any).serial_id]
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(String((_ctx.payload as any)?.title || (_ctx.payload as any)?.sku)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createVNode(_component_ozn_button, {
                        class: "selectable-product__button",
                        disabled: _ctx.disabled,
                        onClick: _withModifiers(_ctx.select, ["stop"])
                      }, null, 8, ["disabled", "onClick"]), [
                        [_vShow, !_ctx.selected]
                      ]),
                      _withDirectives(_createVNode(_component_ozn_button, {
                        class: "selectable-product__button",
                        disabled: _ctx.disabled,
                        onClick: _withModifiers(_ctx.remove, ["stop"])
                      }, null, 8, ["disabled", "onClick"]), [
                        [_vShow, _ctx.selected]
                      ])
                    ])
                  ]),
                  (_ctx.active)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _renderSlot(_ctx.$slots, "expanded", {
                          payload: _ctx.payload,
                          resolved: _ctx.resolved,
                          disabled: _ctx.disabled,
                          select: _ctx.select,
                          remove: _ctx.remove
                        }, undefined, true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.layout === _ctx.ItemLayoutType.Receive)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["receive-item", { 'receive-item--selected': _ctx.selected}])
              }, [
                (_ctx.simpleLink)
                  ? (_openBlock(), _createBlock(_component_simple_link, {
                      key: 0,
                      class: "receive-item__simple-link-container",
                      id: _ctx.payload,
                      level: 1,
                      store: _ctx.currentCache,
                      "onUpdate:store": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentCache) = $event))
                    }, {
                      default: _withCtx(({ resolved }) => [
                        _renderSlot(_ctx.$slots, "quantity-container", {}, () => [
                          _createVNode(_component_quantity_container, {
                            quantity: _ctx.quantity,
                            partial: _ctx.partial,
                            "display-disabled": _ctx.disabled,
                            placeholder: "-",
                            class: _normalizeClass({'partial': _ctx.partial})
                          }, null, 8, ["quantity", "partial", "display-disabled", "class"]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["receive-item__container", {'receive-item__container--active': _ctx.payload == _ctx.active}])
                          }, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _renderSlot(_ctx.$slots, "subtitle", { resolved: resolved }, () => [
                                    (_ctx.subtitle)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.subtitle), 1))
                                      : _createCommentVNode("", true)
                                  ], true)
                                ]),
                                _createElementVNode("div", _hoisted_29, _toDisplayString(resolved?.name || resolved?.id || resolved?.title || '...'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _withDirectives(_createVNode(_component_ozn_button, {
                                  class: "receive-item__button",
                                  disabled: _ctx.disabled,
                                  onClick: _withModifiers(_ctx.select, ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "select-button", {}, () => [
                                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "t-icon" }, "e", -1))
                                    ], true)
                                  ]),
                                  _: 3
                                }, 8, ["disabled", "onClick"]), [
                                  [_vShow, !_ctx.selected]
                                ]),
                                _withDirectives(_createVNode(_component_ozn_button, {
                                  class: "receive-item__button",
                                  disabled: _ctx.disabled,
                                  onClick: _withModifiers(_ctx.remove, ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "remove-button", {}, () => [
                                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "t-icon" }, "l", -1))
                                    ], true)
                                  ]),
                                  _: 3
                                }, 8, ["disabled", "onClick"]), [
                                  [_vShow, _ctx.selected]
                                ])
                              ])
                            ]),
                            (_ctx.payload == _ctx.active)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _renderSlot(_ctx.$slots, "expanded", {}, () => [
                                    _cache[11] || (_cache[11] = _createElementVNode("img", {
                                      class: "receive__ean-icon",
                                      src: _imports_0
                                    }, null, -1)),
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(String(resolved?.stock_item?.ean || resolved?.ean || '-') || 'Item has no ean...'), 1)
                                  ], true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], true)
                      ]),
                      _: 3
                    }, 8, ["id", "store"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _renderSlot(_ctx.$slots, "quantity-container", {}, () => [
                        _createVNode(_component_quantity_container, {
                          quantity: _ctx.quantity,
                          partial: _ctx.partial,
                          placeholder: "-",
                          "display-disabled": _ctx.disabled,
                          class: _normalizeClass({'partial': _ctx.partial})
                        }, null, 8, ["quantity", "partial", "display-disabled", "class"]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["receive-item__container", {'receive-item__container--active': _ctx.payload.id == _ctx.active}])
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _renderSlot(_ctx.$slots, "subtitle", {}, () => [
                                  (_ctx.subtitle)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.subtitle), 1))
                                    : _createCommentVNode("", true)
                                ], true)
                              ]),
                              _createElementVNode("div", _hoisted_38, _toDisplayString(String((_ctx.payload as any)?.title || (_ctx.payload as any)?.sku )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _withDirectives(_createVNode(_component_ozn_button, {
                                class: "receive-item__button",
                                disabled: _ctx.disabled,
                                onClick: _withModifiers(_ctx.select, ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _renderSlot(_ctx.$slots, "select-button", {}, () => [
                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "t-icon" }, "e", -1))
                                  ], true)
                                ]),
                                _: 3
                              }, 8, ["disabled", "onClick"]), [
                                [_vShow, !_ctx.selected]
                              ]),
                              _withDirectives(_createVNode(_component_ozn_button, {
                                class: "receive-item__button",
                                disabled: _ctx.disabled,
                                onClick: _withModifiers(_ctx.remove, ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _renderSlot(_ctx.$slots, "remove-button", {}, () => [
                                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "t-icon" }, "l", -1))
                                  ], true)
                                ]),
                                _: 3
                              }, 8, ["disabled", "onClick"]), [
                                [_vShow, _ctx.selected]
                              ])
                            ])
                          ]),
                          (_ctx.payload.id == _ctx.active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _renderSlot(_ctx.$slots, "expanded", {}, () => [
                                  _cache[14] || (_cache[14] = _createElementVNode("img", {
                                    class: "selectable-product__ean-icon",
                                    src: _imports_0,
                                    style: {"display":"inline-block","margin-right":"5px","margin-bottom":"2px"}
                                  }, null, -1)),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["selectable-product__ean", {'warn darken': !(_ctx.payload as any)?.ean?.length}])
                                  }, _toDisplayString((_ctx.payload as any)?.ean?.length ? (_ctx.payload as any)?.ean[0] : ((_ctx.payload as any)?.sku || 'item has no ean...')), 3)
                                ], true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ], true)
                    ]))
              ], 2))
            : _createCommentVNode("", true)
        ], true),
    (_ctx.active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          (!_ctx.layout)
            ? _renderSlot(_ctx.$slots, "expanded", {
                key: 0,
                payload: _ctx.payload,
                disabled: _ctx.disabled,
                select: _ctx.select,
                remove: _ctx.remove
              }, undefined, true)
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 34))
}